import discardPopOption from './actions/discardPopOption';
import savePopOption from './actions/savePopOption';
import PopImapFull from './components/PopImapFull';
import isPopOptionDirty from './utils/isPopOptionDirty';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var PopImapOption = {
    key: 'popImap',
    titleStringKey: 'optionTitle_popAndImap',
    searchTermsStringKey: 'optionTitle_popAndImap',
    fullOptionFormSettings: {
        render: function () { return React.createElement(PopImapFull, null); },
        isDirty: isPopOptionDirty,
        onSave: savePopOption,
        onDiscard: discardPopOption,
    },
    isHidden: function () { return !isControlFeatureEnabled('fwk-option-popImap'); },
};
export default PopImapOption;
//# sourceMappingURL=PopImapOption.js.map